export default __webpack_public_path__ + "static/media/529.0002ce40.gif";